import React, { FC } from "react";

export interface FormSubmitButtonProps {
  text: string;
  disabled: boolean;
}

export const FormSubmitButton: FC<FormSubmitButtonProps> = ({
  text,
  disabled,
}) => (
  <div className="l-half-tablet align-end">
    <button
      className="button button-ghost-primary button-prominent"
      type="submit"
      disabled={disabled}
    >
      {text}
    </button>
  </div>
);
